import { render, staticRenderFns } from "./AssetsImage.vue?vue&type=template&id=146f33b0&scoped=true&"
import script from "./AssetsImage.vue?vue&type=script&lang=js&"
export * from "./AssetsImage.vue?vue&type=script&lang=js&"
import style0 from "./AssetsImage.vue?vue&type=style&index=0&id=146f33b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146f33b0",
  null
  
)

export default component.exports